import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Observer } from 'rxjs';
import { environment } from '../../environments/environment';
import { SecretService } from './secret.service';
import { Router } from '@angular/router';
// import { AppConfig } from './config/app.config';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  baseUrl: any;
  urlSlug: any;
  // siteBaseUrl: any;
  constructor(
    private http: HttpClient,
    private secretServ: SecretService,
    private router: Router
  ) {
    this.baseUrl = environment.baseUrl;
    // this.siteBaseUrl = environment.siteBaseUrl;
    this.urlSlug = this.secretServ.decryptLocalStorageData(localStorage.getItem('urlSlug')) as any;
  }

  /**
   * Service for register the tanent of CM.
   * Created by Rashmi Ranjan
   * @Phantom
   * CreatedOn 03-Dec-2021
   */

  customNavigation(path: string, queryParams: any = null) {
    // console.log('urlslug changed', this.urlSlug);
    // console.log('redirect route', { queryParams });
    this.router.navigate([this.urlSlug + path], { queryParams });
  }

  listAdminUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/list-admin-user', payload);
  }

  listUsers(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/list-users', payload);
  }

  deletedMemberList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/deleted-member-list', payload);
  }

  restoreMember(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `user/${id}/restore-member`, {});
  }

  updateMemberSettings(id: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `user/${id}/user-settings`, payload);
  }

  deleteMember(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `user/${id}/hard-delete`, {});
  }
  // viewUser(): Observable<any> {
  //   return this.http.get(this.baseUrl + 'user/view-user');
  // }
  viewUserId(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/view-user', payload);
  }
  addAdminUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-admin-user', payload);
  }
  deleteUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-user', payload);
  }
  updateUserStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-user-status', payload);
  }
  bulkUpdateUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/bulk-update-user', payload);
  }
  getSupervisorList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-supervisor-user');
  }
  getEngineerList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-engineer-user');
  }
  // getClientList(): Observable<any> {
  //   return this.http.get(this.baseUrl + 'user/list-client-user');
  // }
  getClientList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-clients');
  }
  getActiveUsersCount(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/get-active-user-count');
  }

  // other users list
  getAllOtherUsers(): Observable<any> {
    this.taskList;
    return this.http.get(this.baseUrl + 'user/list-other-user');
  }

  //Country list
  getCountryList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'master/list-country', payload);
  }

  getCurrencyList(payload: any): Observable<any> {
    return this.http.get(this.baseUrl + 'master/get-currency-list', payload);
  }
  changeImage(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/change-profile-pic', payload);
  }
  deleteImage(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/change-profile-pic', payload);
  }

  saveSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-supervisor-user', payload);
  }
  getSupervisors(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/get-supervisors', payload);
  }
  viewSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/view-supervisor', payload);
  }
  deleteSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-supervisor', payload);
  }
  updateSupervisorStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-supervisor-status', payload);
  }
  bulkUpdateSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/bulk-update-supervisor', payload);
  }

  saveAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-area-manager-user', payload);
  }
  getAreaManagers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/get-area-managers');
  }
  viewAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/view-area-manager', payload);
  }
  deleteAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-area-manager', payload);
  }
  updateAreaManagerStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-area-manager-status', payload);
  }
  bulkUpdateAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/bulk-update-area-manager-status', payload);
  }

  saveEngineer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-engineer-user', payload);
  }
  getEngineers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/get-engineers');
  }
  viewEngineer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/view-engineer', payload);
  }
  deleteEngineer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-engineer', payload);
  }
  updateEngineerStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-engineer-status', payload);
  }
  bulkUpdateEngineer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/bulk-update-engineer', payload);
  }

  updateImage(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-image', payload);
  }
  updatePassword(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-password', payload);
  }
  resetPassword(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/resetPassword', payload);
  }
  sendQRViaEmail(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/sendQRbyEmail', payload);
  }
  showQR(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/singleUserQR', payload);
  }

  getSamClient(): Observable<any> {
    return this.http.post(this.baseUrl + 'site/fetch-CD-ccsClientBE', {});
  }

  getSamSite(country_code: any, sage_no: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/fetch-CD-ccsSitesBE', {
      country_code,
      sage_no,
    });
  }

  forgotPass(payload: { email: string }): Observable<any> {
    // console.log(payload);
    return this.http.post(this.baseUrl + 'user/forgot-password', payload);
  }

  resetNewPassword(email: string, token: string, newPassword: string): Observable<any> {
    return this.http.post(this.baseUrl + 'user/reset-new-password', {
      email,
      token,
      newPassword,
    });
  }

  sendContact(): Observable<any> {
    return this.http.post(this.baseUrl + 'user/send-request-by-email ', {
      _id: this.secretServ.decryptLocalStorageData(localStorage.getItem('user_id')),
      email: this.secretServ.decryptLocalStorageData(localStorage.getItem('emailId')),
    });
  }

  importSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/import-supervisor', payload);
  }

  importAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/import-area-manager', payload);
  }

  importClient(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/import-client', payload);
  }

  clientSync(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/clientSyncAllData', payload);
  }

  saveOperationManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-operation-manager-user', payload);
  }

  saveRole(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/role-change-Users', payload);
  }
  // http://localhost:8000/auth/api/v1/user/role-change-Users

  listOperationManagers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-operation-manager-user');
  }

  deleteOperationManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-operation-manager-user', payload);
  }

  updateOperationManagerStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-operation-manager-status', payload);
  }

  bulkUpdateOperationManagerStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/bulk-update-operation-manager-status', payload);
  }

  countryWiseClientList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/country-wise-client-list', payload);
  }

  listAllClient(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/list-all-client', payload);
  }

  listSuperAdminUser(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-super-admin-user');
  }

  clientSupportTicket(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/client-support-ticket', payload);
  }

  /****** Support Manager *******/
  saveSupportManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-support-manager', payload);
  }

  listSupportManager(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-support-manager');
  }

  listActiveSupportManager(): Observable<any> {
    return this.http.get(this.baseUrl + 'master/support-manager-dropdown-list');
  }

  checkClientQEHS(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/check-client-qehs', payload);
  }

  roleDropdownList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'master/role-dropdown-list', payload);
  }

  syncAllAdmin(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/adminSyncAllData');
  }

  syncAllOpManager(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/OMSyncAllData');
  }

  syncAllSupportManager(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/SMSyncAllData');
  }

  getCalendarData(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/fetch-calender', payload);
  }

  getBCCompanyList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/BC-companyList');
  }

  getVanTrackingCustomerList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/vanTracking-customerList');
  }

  getVanTrackingDeviceLocation(payload: any, accessToken: any, token: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        authorization: `Bearer ${accessToken}, Token ${token}`,
      }),
    };
    return this.http.post(
      this.baseUrl + 'user/vanTracking-customer-device-Location',
      payload,
      httpOptions
    );
  }

  getAllSiteAM(data: any) {
    const payload = { am_emails: [...data] };
    return this.http.post(this.baseUrl + 'user/get-all-site-ams', payload);
  }

  getAllRoles() {
    return this.http.get(this.baseUrl + 'user/all-roles');
  }

  getAllStockWarehouse() {
    return this.http.get(this.baseUrl + 'master/get-stock-warehouse-list');
  }

  getClientContractList(clientId: string) {
    return this.http.post(this.baseUrl + `manageClient/client/${clientId}/contracts`, null);
  }
  getClientCountryList(clientId: string) {
    return this.http.post(this.baseUrl + `manageClient/client/${clientId}/countries`, null);
  }

  getClientSiteList(clientId: string, params?: any) {
    return this.http.post(this.baseUrl + `manageClient/client/${clientId}/sites`, params);
  }
  getMultiClientSiteList(clientIds: string, params?: any) {
    return this.http.post(this.baseUrl + `manageClient/client-sites`, {
      clientIds,
      ...params,
    });
  }

  createJob(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/create', payload);
  }

  getJobsList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-jobs', payload);
  }
  getExportJobsList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/export-jobs', payload);
  }

  getJobDetails(jobId: string, params?: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/details`, params);
  }

  importSite(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/save-bulk-site', payload);
  }

  importBulkMachineSite(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/import-site-machine', payload);
  }

  attachJobImages(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/attach-images`, payload);
  }

  // get all machines of a site
  fetchSiteMachines(siteId: string) {
    return this.http.post(this.baseUrl + `jobs/get-site-machines/${siteId}`, {});
  }

  attachMachineToJob(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/attach-a-machine`, payload);
  }

  detachMachineFromJob(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/detach-a-machine`, payload);
  }

  // job machines
  getJobMachines(jobId: string): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/machines`, {});
  }
  // assign-engineer
  assignEngineerToJob(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/assign-engineer`, payload);
  }
  // getAllEngineersForJob
  getAllEngineersForJob(jobId: string) {
    return this.http.post(this.baseUrl + `jobs/${jobId}/available-engineers`, {});
  }

  // getAllEngineersForMultiStepJob
  getAllEngineersForMultiStepJob(payload: { siteId?: string } = {}) {
    return this.http.post(this.baseUrl + 'jobs/all-engineers', payload);
  }

  // getAssignedEngineerLogs
  getAssignedEngineerLogs(jobId: string) {
    return this.http.post(this.baseUrl + `jobs/${jobId}/assigned-engineer-logs`, {});
  }
  // Job Logs
  getJobLogs(jobId: string) {
    return this.http.post(this.baseUrl + `jobs/${jobId}/logs`, {});
  }

  // all statuses
  getAllStatuses() {
    return this.http.get(this.baseUrl + 'jobs/job-statuses');
  }

  // change job status
  // changeJobStatus(jobId: string, payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + `jobs/${jobId}/change-status`, payload);
  // }

  getDeletedJobsList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-deleted-jobs', payload);
  }

  // restoreJob
  restoreJob(jobId: string): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/restore`, {});
  }
  // permanentDeleteJob
  permanentDeleteJob(jobId: string): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/permanent-delete`, {});
  }

  getSiteJobDetails(siteId: string, payload: any) {
    return this.http.post(this.baseUrl + `jobs/get-site-jobs/${siteId}`, payload);
  }

  // work-sessions
  getWorkSessions(jobId: string) {
    return this.http.post(this.baseUrl + `jobs/${jobId}/work-sessions`, {});
  }

  // session-info
  getSessionInfo(jobId: string, sessionId: string) {
    return this.http.post(this.baseUrl + `jobs/${jobId}/work-sessions/${sessionId}/info`, {});
  }

  getManufacturerAc(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/get-manufacturer-list-ac', payload);
  }

  getOpenedJobsListForDashboard(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-opened-jobs', payload);
  }

  getCompletedJobsListForDashboard(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-completed-jobs', payload);
  }

  getDashboardJobs(listType: string, limit: number, params: object = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-dashboard-jobs', { listType, limit, ...params });
  }

  getDashboardJobs2(params: object = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-dashboard-jobs', { ...params });
  }

  errorList(params?: any) {
    return this.http.get(this.baseUrl + 'jobs/get-error-list', params);
  }

  addMachineService(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/add-machine-service', payload);
  }

  getMachineServiceDetails(id: string): Observable<any> {
    return this.http.get(this.baseUrl + `machine/get-service-details/${id}`);
  }

  getJobServiceDetails(jobId: string): Observable<any> {
    return this.http.get(this.baseUrl + `machine/get-job-service-details/${jobId}`);
  }

  deleteServiceDetails(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/delete-service-details', payload);
  }

  eolMachineList(params?: any) {
    const queryParams: any = {};
    if (params?.site_id) {
      queryParams.site_id = params.site_id;
    }
    if (params?.machine_id) {
      queryParams.machine_id = params.machine_id;
    }
    return this.http.get(this.baseUrl + 'machine/get-eol-machine-list', { params: queryParams });
  }

  updateEolMachineStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/update-eol-machine-status', payload);
  }

  //get machineInstance details
  getMachineInstanceDetails(machineInstanceId: string) {
    return this.http.get(this.baseUrl + `machine/machine-instance-details/${machineInstanceId}`);
  }

  bulkDeleteSiteMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/bulk-delete-site-machine', payload);
  }

  getAllClientSiteDetails(clientId: string) {
    return this.http.get(this.baseUrl + `site/get-client-site-details/${clientId}`);
  }

  getPartsRequestDetails(jobId: string): Observable<any> {
    return this.http.get(this.baseUrl + `machine/get-parts-request-details/${jobId}`);
  }

  getMachineReplacementDetails(jobId: string): Observable<any> {
    return this.http.get(this.baseUrl + `machine/get-machine-replacement-details/${jobId}`);
  }

  getPartNameListAc(query: string, queryParams: any = {}): Observable<any> {
    let params = {
      query,
      ...queryParams,
    };

    return this.http.get(this.baseUrl + `jobs/part-name-ac`, {
      params,
    });
  }

  getUnassignedClientSiteDetails(clientId: string) {
    return this.http.get(this.baseUrl + `site/get-unAssigned-client-site-details/${clientId}`);
  }

  getAreaManagerSiteList(id: string) {
    return this.http.get(this.baseUrl + `site/area-manager-site-list/${id}`);
  }

  //Restore client
  restoreClient(clientId: string): Observable<any> {
    return this.http.post(this.baseUrl + `manageClient/${clientId}/restore`, {});
  }

  //Deleted client list
  deletedClientList() {
    return this.http.get(this.baseUrl + 'manageClient/get-deleted-clients');
  }

  //Serial no list
  getAllSerialNo(machineId: string, type: string | null) {
    let url = this.baseUrl + `machine/get-machine-instance-details/${machineId}`;

    if (type) {
      url += `?type=${type}`;
    }

    return this.http.get(url);
  }

  // Add Serial No Form
  addSerialNO(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/add-serialNo', payload);
  }

  // Dashboard
  getDashboardCounts(payload: any = {}): Observable<any> {
    return this.http.get(this.baseUrl + 'admin-dashboard/all-counts', payload);
  }

  getRevenueGraph(payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'admin-dashboard/revenue-graph', payload);
  }

  getJobsGraph(payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'admin-dashboard/job-status-graph', payload);
  }

  createCustomer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'customer/create-customer', payload);
  }

  // fetch list of customers
  getCustomers(payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'customer/all-list', payload);
  }

  // update customer
  updateCustomer(customerId: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `customer/update-customer/${customerId}`, payload);
  }

  // get single customer details
  getCustomerDetails(customerId: string): Observable<any> {
    return this.http.get(this.baseUrl + `customer/customer-details/${customerId}`);
  }

  // delete customer
  deleteCustomer(customerId: string): Observable<any> {
    return this.http.put(this.baseUrl + `customer/delete-customer/${customerId}`, {});
  }

  // approve customer
  approveCustomer(customerId: string): Observable<any> {
    return this.http.post(this.baseUrl + `customer/approve-customer/${customerId}`, {});
  }

  // job types
  getJobTypes(
    filters: Object = { deletedAt: null, active: 1 },
    orderBy: Record<string, 1 | -1> = { name: 1 }
  ): Observable<any> {
    let params = { filters, orderBy };
    return this.http.post(this.baseUrl + 'jobs/job-types', params);
  }

  createJobType(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/job-types/create', payload);
  }

  updateJobType(jobTypeId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/job-types/${jobTypeId}/update`, payload);
  }

  deleteJobType(jobTypeId: string, payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/job-types/${jobTypeId}/delete`, payload);
  }

  blockUnblockJobType(jobTypeId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/job-types/${jobTypeId}/status-change`, payload);
  }

  bulkDeleteBlockUnblockJobType(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/job-types/bulk-update', payload);
  }

  putJobOnhold(jobId: string, payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/put-on-hold-special`, payload);
  }

  restoreMachineApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/restore-workshop-machine', payload);
  }

  assignUnassignLocationApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/assign-unassign-site', payload);
  }

  bulkAssignUnassignLocationApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/bulk-assign-unassign-site', payload);
  }

  importAssignSite(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/import-assign-site', payload);
  }

  getPatJobList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-pat-jobs', payload);
  }

  addScheduledPAT(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/add-pat-schedule', payload);
  }

  deleteScheduledPAT(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/delete-pat-schedule', payload);
  }

  // Parts Management
  createPartsApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parts/add-parts', payload);
  }

  listPartsApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parts/parts-list', payload);
  }

  productGroupDropDownApi(): Observable<any> {
    return this.http.get(this.baseUrl + 'parts/product-group-list');
  }

  updatePartsStatusApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parts/update-part-status', payload);
  }

  deletePartsStatusApi(partId: string): Observable<any> {
    return this.http.post(this.baseUrl + `parts/${partId}/delete-part`, {});
  }

  viewPartsApi(partId: string): Observable<any> {
    return this.http.get(this.baseUrl + `parts/get-part-details/${partId}`);
  }

  bulkUpdatePartsApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parts/bulk-update-part', payload);
  }

  //Prices Management
  createPricesApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parts/add-prices', payload);
  }

  listPricesApi(partId: any): Observable<any> {
    return this.http.get(this.baseUrl + `parts/get-price-details/${partId}`);
  }

  //Quotes Management
  quotesListApi(payload: any) {
    return this.http.post(this.baseUrl + 'quote/quotes-list', payload);
  }

  sendQuotesApi(payload: any) {
    return this.http.post(this.baseUrl + 'quote/save-quote', payload);
  }

  // getNextQuoteID() {
  //   return this.http.post(this.baseUrl + 'quote/get-next-quote-id', {});
  // }

  //Manage Leads
  leadList(payload: any) {
    return this.http.post(this.baseUrl + 'leads/lead-list', payload);
  }

  archivedLeadList(payload: any) {
    return this.http.post(this.baseUrl + 'leads/archived-leads', payload);
  }

  createLead(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leads/add-lead', payload);
  }

  archiveLead(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${id}/archive-lead`, {});
  }

  restoreLead(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${id}/restore-lead`, {});
  }

  deleteLead(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${id}/delete-lead`, {});
  }

  leadStatusChange(id: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${id}/change-status`, payload);
  }

  addLeadContact(id: string, contact: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${id}/add-contact`, {
      contact: contact,
    });
  }
  updateLeadContact(id: string, contactId: string, contact: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${id}/update-contact`, {
      contactId: contactId,
      contact: contact,
    });
  }

  leadWiseDeals(id: string) {
    return this.http.get(this.baseUrl + `leads/${id}/deals`);
  }

  leadWiseProposals(id: string) {
    return this.http.get(this.baseUrl + `leads/${id}/proposals`);
  }

  updateLeadDetails(id: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${id}/update-lead`, payload);
  }

  getLeadDetails(id: string) {
    return this.http.get(this.baseUrl + `leads/${id}/view-lead`);
  }

  getLeadContacts(id: string) {
    return this.http.get(this.baseUrl + `leads/${id}/get-contacts`);
  }

  viewLead(id: string) {
    return this.http.get(this.baseUrl + `leads/${id}/lead-details`);
  }

  deleteLeadContact(id: string, contactId: string): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${id}/delete-contact`, {
      contactId: contactId,
    });
  }

  importContacts(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leads/import-contacts', payload);
  }

  updateLeadStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leads/update-lead-status', payload);
  }

  autoCompleteLeads(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leads/autoComplete-lead-list', payload);
  }

  importLead(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leads/import-lead', payload);
  }

  //Deal list
  dealList(payload: any) {
    return this.http.post(this.baseUrl + 'deal/get-all-deals', payload);
  }

  lossDealList(payload: any) {
    return this.http.post(this.baseUrl + 'deal/loss-deals', payload);
  }

  autoCompleteDeals(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'deal/autoComplete-deal-list', payload);
  }

  userLeadList(payload: any) {
    return this.http.post(this.baseUrl + 'leads/my-leads', payload);
  }

  archivedDeal(payload: any) {
    return this.http.post(this.baseUrl + 'deal/archived-deals', payload);
  }

  createDeal(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'deal/add-deal', payload);
  }

  importDeal(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'deal/import-deal', payload);
  }

  updateDeal(payload: any): Observable<any> {
    return this.http.put(this.baseUrl + 'deal/update-deal', payload);
  }

  dealStatusChange(id: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `deal/${id}/change-status`, payload);
  }

  // deleteDeal(id: string): Observable<any> {
  //   // dealId, deletedBy
  //   return this.http.patch(this.baseUrl + `deal/soft-delete-deal`, {dealId:id});
  // }

  // FetchDeal(id: any): Observable<any> {
  //   return this.http.get(this.baseUrl + 'deal/single-deal', {
  //     params: { _id: id }
  //   });
  // }

  FetchDeal(id: any): Observable<any> {
    return this.http.get(this.baseUrl + 'deal/single-deal', {
      params: { _id: id },
    });
  }

  dealUpdate(/* id: string, */ payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `deal/update-deal`, payload);
  }

  archiveDeal(id: string): Observable<any> {
    return this.http.patch(this.baseUrl + `deal/soft-delete-deal`, {
      dealId: id,
    });
  }

  restoreDeal(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `deal/${id}/restore-deal`, {});
  }

  deleteDeal(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `deal/${id}/hard-delete-deal`, {});
  }

  //Dashboard API
  dashboardCounts(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'dashboard/all-counts', payload);
  }

  // proposal
  createProposal(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'proposal/add-proposal', payload);
  }
  updateProposal(payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `proposal/update-proposal`, payload);
  }
  proposalListByLead(leadId: any) {
    return this.http.get(this.baseUrl + `proposal/${leadId}/list-proposal`);
  }

  // Documents
  addDocument(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leads/documents/add-document', payload);
  }
  updateDocument(id: any, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/documents/${id}/update-document`, payload);
  }
  documentListByLead(leadId: any) {
    return this.http.get(this.baseUrl + `leads/documents/${leadId}/get-documents`);
  }
  deleteDocument(id: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/documents/${id}/delete-document`, {});
  }

  //Call log
  createCallLog(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'callLog/add-callLog', payload);
  }

  callLogList(leadId: any) {
    return this.http.get(this.baseUrl + `callLog/${leadId}/list-callLog`);
  }

  //Task
  createTask(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'tasks/add-task', payload);
  }

  updateTask(payload: any, id: any): Observable<any> {
    return this.http.put(this.baseUrl + `tasks/${id}/update-task`, payload);
  }

  // taskList(leadId: any) {
  //   return this.http.get(this.baseUrl + `tasks/${leadId}/task-list`);
  // }

  deleteTask(taskId: string): Observable<any> {
    return this.http.put(this.baseUrl + `tasks/delete-task?id=${taskId}`, {});
  }

  changeTaskStatus(id: any): Observable<any> {
    return this.http.put(this.baseUrl + `tasks/${id}/change-task-status`, {});
  }

  // lead emails
  listLeadEmails(leadId: string): Observable<any> {
    return this.http.get(this.baseUrl + `leads/${leadId}/emails`, {
      params: {
        // leadId
      },
    });
  }

  addLeadEmail(leadId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${leadId}/emails`, payload);
  }

  deleteLeadEmail(leadId: string, emailId: string): Observable<any> {
    return this.http.delete(this.baseUrl + `leads/${leadId}/emails/${emailId}`);
  }

  updateLeadEmail(leadId: string, emailId: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `leads/${leadId}/emails/${emailId}`, payload);
  }

  getLeadEmailDetails(leadId: string, emailId: string): Observable<any> {
    return this.http.get(this.baseUrl + `leads/${leadId}/emails/${emailId}`);
  }

  sendLeadEmail(leadId: string, emailId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${leadId}/emails/${emailId}/send`, payload);
  }

  followupEmail(emailId: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${emailId}/email-followup`, {});
  }

  /*
    :leadId/meetings/
    :leadId/meetings/
    :leadId/meetings/:id
    :leadId/meetings/:id
    :leadId/meetings/:id
    :leadId/follow-up
  */
  listLeadMeetings(leadId: string): Observable<any> {
    return this.http.get(this.baseUrl + `leads/${leadId}/meetings`);
  }

  addLeadMeeting(leadId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${leadId}/meetings`, payload);
  }

  updateLeadMeeting(leadId: string, meetingId: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `leads/${leadId}/meetings/${meetingId}`, payload);
  }

  deleteLeadMeeting(leadId: string, meetingId: string): Observable<any> {
    return this.http.delete(this.baseUrl + `leads/${leadId}/meetings/${meetingId}`);
  }

  getLeadMeetingDetails(leadId: string, meetingId: string): Observable<any> {
    return this.http.get(this.baseUrl + `leads/${leadId}/meetings/${meetingId}`);
  }

  //Notification API
  notiFicationList(): Observable<any> {
    return this.http.get(this.baseUrl + `notification/notification-list`);
  }

  markNotificationAsRead(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `notification/${id}/read-notification`, {});
  }

  markAllNotificationsAsRead(): Observable<any> {
    return this.http.post(this.baseUrl + 'notification/read-all-notification', {});
  }

  addMeetingFollowUp(leadId: string, meetingId: string, payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + `leads/${leadId}/meetings/${meetingId}/follow-up`,
      payload
    );
  }

  /*
    post "/:leadId/follow-ups/"
    get "/:leadId/follow-ups/"
    get "/:leadId/follow-ups/:id"
    put "/:leadId/follow-ups/:id"
    delete "/:leadId/follow-ups/:id"
  */

  listLeadFollowUps(leadId: string): Observable<any> {
    return this.http.get(this.baseUrl + `leads/${leadId}/follow-ups`);
  }

  addLeadFollowUp(leadId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${leadId}/follow-ups`, payload);
  }

  updateLeadFollowUp(leadId: string, followUpId: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `leads/${leadId}/follow-ups/${followUpId}`, payload);
  }

  deleteLeadFollowUp(leadId: string, followUpId: string): Observable<any> {
    return this.http.delete(this.baseUrl + `leads/${leadId}/follow-ups/${followUpId}`);
  }

  getLeadFollowUpDetails(leadId: string, followUpId: string): Observable<any> {
    return this.http.get(this.baseUrl + `leads/${leadId}/follow-ups/${followUpId}`);
  }

  // Report API
  saveReport(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'reports/save-report', payload);
  }

  fetchReport(id: string) {
    return this.http.get(this.baseUrl + `reports/${id}/fetch-report`);
  }

  deleteReport(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `reports/${id}/delete-report`, {});
  }

  // activities
  getActivitiesList(leadId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${leadId}/activities`, payload);
  }

  // activities-grouped
  getActivitiesGrouped(leadId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${leadId}/activities-grouped`, payload);
  }
  // all-activities-grouped
  getAllActivitiesGrouped(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/all-activities-grouped`, payload);
  }
  // all-activities-all-activities-paginated
  getAllActivitiesPaginated(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/all-activities-paginated`, payload);
  }

  // activity-logs-paginated
  getActivityLogsPaginated(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/activity-logs-paginated`, payload);
  }

  // update company logo
  updateCompanyLogo(
    leadId: string,
    payload: { logo?: string; deleteLogo?: true }
  ): Observable<any> {
    return this.http.post(this.baseUrl + `leads/${leadId}/update-company-logo`, payload);
  }

  // Quote API
  getNextQuoteID() {
    return this.http.post(this.baseUrl + 'quotes/get-next-quoteid', {});
  }

  fetchQuoteItems() {
    return this.http.post(this.baseUrl + 'quotes/fetch-quote-items', {});
  }

  addQuote(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'quotes/add-quote', payload);
  }

  quoteList(leadId: any) {
    return this.http.get(this.baseUrl + `quotes/${leadId}/get-quotes`);
  }

  deleteQuote(id: any): Observable<any> {
    return this.http.post(this.baseUrl + `quotes/${id}/delete-quote`, {});
  }

  updateQuote(id: any, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `quotes/${id}/update-quote`, payload);
  }

  //Send to mobilization
  sendProject(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `deal/add-project`, payload);
  }

  //Save Client
  addClient(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'onboardClients/add-client', payload);
  }

  onboardClientList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'onboardClients/list-Clients', payload);
  }

  clientContractList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'onboardClients/list-contracts', payload);
  }

  getClientDetails(id: string) {
    return this.http.get(this.baseUrl + `onboardClients/get-single-client/${id}`);
  }

  autoCompleteClients(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'onboardClients/autoComplete-client-list', payload);
  }

  deleteClientContract(id: any): Observable<any> {
    return this.http.put(this.baseUrl + `onboardClients/delete-client-contract/${id}`, {});
  }

  deleteClient(id: any): Observable<any> {
    return this.http.post(this.baseUrl + `onboardClients/delete-client/${id}`, {});
  }

  contactsListPaginated(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'contacts/contact-list', payload);
  }

  getDashboardFollowUpMeetingsPaginated(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'dashboard/follow-up-meetings', payload);
  }

  getDashboardFollowUpTasksPaginated(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'dashboard/follow-up-tasks', payload);
  }

  getDashboardFollowUpEmailsPaginated(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'dashboard/follow-up-emails', payload);
  }

  hubspotCompanyListPaginated(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'company/hubspot-companies', payload);
  }
  hubspotCompanyactivities(hubspotId: string, payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'company/hubspot-activities', {
      companyId: hubspotId,
      ...payload,
    });
  }

  // Providers
  providerList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'provider/provider-list', payload);
  }

  //Jobs
  getNextJobID() {
    return this.http.post(this.baseUrl + 'jobs/get-next-jobId', {});
  }

  addJob(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/add-job', payload);
  }

  jobList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/list-jobs', payload);
  }

  deleteJob(id: any): Observable<any> {
    return this.http.put(this.baseUrl + `jobs/delete-job/${id}`, {});
  }

  singleJobDetails(id: any): Observable<any> {
    return this.http.get(this.baseUrl + `jobs/job-details/${id}`);
  }

  updateJob(jobId: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `jobs/update-job/${jobId}`, payload);
  }

  changeJobStatus(jobId: any, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `jobs/change-job-status/${jobId}`, payload);
  }

  assignProviderToJOb(jobId: any, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `provider/assign-provider-to-job/${jobId}`, payload);
  }

  taskList(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/subtasks/${jobId}`, payload);
  }

  setJobProfit(jobId: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `jobs/set-profit-cost/${jobId}`, payload);
  }

  updateProviderPayment(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/update-provider-payment/${jobId}`, payload);
  }

  updateCustomerPayment(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/update-customer-payment/${jobId}`, payload);
  }

  //OTP Validation
  generateOtp(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'otp/generate-otp', payload);
  }

  validateOtp(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'otp/verify-otp', payload);
  }

  resendOtp(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'otp/resend-otp', payload);
  }

  //Comments
  addComment(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `comments/add-comment/${jobId}`, payload);
  }

  updateComment(jobId: string, commentId: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `comments/update-comment/${jobId}/${commentId}`, payload);
  }

  commentList(jobId: string): Observable<any> {
    return this.http.post(this.baseUrl + `comments/comments-list/${jobId}`, {});
  }

  deleteComment(jobId: any, commentId: string): Observable<any> {
    return this.http.put(this.baseUrl + `comments/delete-comment/${jobId}/${commentId}`, {});
  }

  // Custom Notifications
  addNotifications(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'custom-notification/add-notifications', payload);
  }

  getNotificationsList(payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'custom-notification/list-notifications', payload);
  }

  sendNotificationToAllCustomers(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'custom-notification/send-notification-all-customers',
      payload
    );
  }

  sendNotificationToAllProviders(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'custom-notification/send-notification-all-providers',
      payload
    );
  }

  deleteNotification(notificationId: string): Observable<any> {
    return this.http.put(
      this.baseUrl + `custom-notification/delete-notification/${notificationId}`,
      {}
    );
  }

  getNotification(notificationId: string): Observable<any> {
    return this.http.post(this.baseUrl + 'custom-notification/list-notifications', {
      _id: notificationId,
    });
  }

  updateNotification(notificationId: string, payload: any): Observable<any> {
    return this.http.put(
      this.baseUrl + `custom-notification/update-notification/${notificationId}`,
      payload
    );
  }

  // Upload image to S3
  uploadImage(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('image', file);
    return this.http.post(this.baseUrl + 'upload/image', formData);
  }

  // Job Status methods
  createJobStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'job-status/create-job-status', payload);
  }

  jobStatusList(): Observable<any> {
    return this.http.get(this.baseUrl + 'job-status/list-job-statuses');
  }

  getJobStatus(id: string): Observable<any> {
    return this.http.get(this.baseUrl + `job-status/getJobStatus/${id}`);
  }

  updateJobStatus(id: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `job-status/update-job-status/${id}`, payload);
  }

  deleteJobStatus(id: string): Observable<any> {
    return this.http.delete(this.baseUrl + `job-status/delete-job-status/${id}`);
  }

  activityLogList(payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + `admin-dashboard/activity-logs`, payload);
  }

  topProviderList(payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + `admin-dashboard/top-provider-list`, payload);
  }

  jobStatusChartLIst(payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + `admin-dashboard/job-status-info`, payload);
  }

  activeCustomerList(payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + `admin-dashboard/active-customers`, payload);
  }

  activeJobs(payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + `admin-dashboard/active-jobs`, payload);
  }

  // Service CMS methods
  createServiceCMS(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'storefront/create-service-cms', payload);
  }

  listServiceCMS(payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'storefront/service-cms-list', payload);
  }

  // Storefront Service CMS list
  serviceCMSList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'storefront/service-cms-list', payload);
  }

  // Storefront Service CMS details by categoryId
  serviceCMSDetails(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'storefront/service-cms-details', payload);
  }

  // Mark trusted company
  markTrustedCompany(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'storefront/markTrustedCompany', payload);
  }
}
